module.exports = __webpack_public_path__ + "img/content7-10.6006baf7.webp";